import * as actions from '@actions'
import { relativeTime } from '@/utils/date'
import { createSyntheticDownload } from '@utils'
import { HUMAN_STATUSES, CHECK_REPORT_STATUS_CREATED } from '@constants'
import { toast } from 'react-toastify'
import cn from 'clsx'

import { BsSortUp, BsSortDown } from 'react-icons/bs'
import { MdFileDownload, MdDelete } from 'react-icons/md'
import useAbortableFetch from '@/hook/useAbortableFetch'
import { useEffect, useState } from 'react'

const CheckReportsTable = ({
    className,
    headers,
    orderField,
    orderDirection,
    onHeaderClick,
    fetchCheckReports,
    reports,
}) => {
    
    const [filteredList, setFilteredList] = useState(reports?.rows)
    const [inputValue, setInputValue] = useState('')
    
    useEffect(() => {
        setFilteredList(reports?.rows)
        setInputValue('')
    }, [reports])
    
    
    const onDeleteCheckReportClick = async id => {
        
        try {
            
            await actions.deleteCheckReports([id])
            await fetchCheckReports()
            toast.success('Deleted check report')
            
        } catch (e) {
            
            console.error('onDeleteCheckReportClick', e)
            toast.error('Failed to delete check report')
            
        }
        
    }
    
    const onDownloadCheckReportClick = async report => {
        
        try {
            
            const res = await actions.downloadCheckReport(report.id)
            
            if (!res) throw new Error('Empty file')
            
            createSyntheticDownload(res, undefined, `${report.fileName}`)
            toast.success('Downloaded report')
            
        } catch (e) {
            
            console.error('onDownloadCheckReportClick', e)
            toast.error('Failed to download report')
            
        }
        
    }
    
    useAbortableFetch(() => {
        
        const reportsFiltered = reports.rows?.filter(e => {
            return (
                e.fileName?.toLowerCase().includes(inputValue?.toLowerCase()) 
                || e.owner?.firstName.toLowerCase().includes(inputValue?.toLowerCase()) 
                || e.owner?.lastName.toLowerCase().includes(inputValue?.toLowerCase())
                || e.status?.toLowerCase().includes(inputValue?.toLowerCase()))
        })
        
        setFilteredList(reportsFiltered)
    }, [inputValue])
    
    return (
        <>    
            <input 
                type="text"
                className="input input-bordered w-full"
                placeholder="Search for a report"
                onChange={e => {
                    setInputValue(e.target.value)
                }}/>
            
            <table className={cn('CheckReports-table table-auto table-pin-rows', className)}>
                
                <thead>
                    <tr>
                        {headers.map(([slug, label]) => (
                            <th
                                key={slug}
                                onClick={() => onHeaderClick(slug)}>
                                <div>
                                    <span>{label}</span>
                                    {orderField === slug && (
                                        orderDirection === 'DESC' ? <BsSortDown /> : <BsSortUp />
                                    )}
                                </div>
                            </th>
                        ))}
                        <th>{/* Actions */}</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredList?.map(it => (
                        <tr key={it.id}>
                            <td className="w-[400px]">
                                <div 
                                    className="line-clamp-1" 
                                    data-tooltip-id="default-tip" 
                                    data-tooltip-content={it.name}>
                                    {it.name}
                                </div>
                            </td>
                            <td>{relativeTime(it.createdAt)}</td>
                            <td>{HUMAN_STATUSES[it.status] ?? it.status}</td>
                            <td>{`${it.owner.firstName} ${it.owner.lastName}`}</td>
                            <td>
                                <div className="flex items-center content-center justify-end gap-3">
                                    <button
                                        className="btn-sm btn action-button btn-primary"
                                        disabled={it.status !== CHECK_REPORT_STATUS_CREATED}
                                        onClick={() => onDownloadCheckReportClick(it)}>
                                        <MdFileDownload className="text-lg" />
                                        Download
                                    </button>
                                    <button
                                        className="btn-sm btn btn-danger action-button"
                                        onClick={() => onDeleteCheckReportClick(it.id)}>
                                        <MdDelete className="text-lg" />
                                        Delete
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
    
}

export default CheckReportsTable
